<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <!-- <h2 class="text-lg font-medium mr-auto" v-if="!isEdit">สร้าง Memo</h2> -->
      <h2 class="text-lg font-medium mr-auto">
        {{ memoEdit ? 'แก้ไข' : 'สร้าง' }} Memo
      </h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0" v-if="!loading">
        <router-link
          type="button"
          :to="{ name: 'memoDocAll' }"
          class="btn box text-gray-700 mr-2 flex items-center ml-auto sm:ml-0"
        >
          <ArrowLeftIcon class="w-4 h-4 mr-2" /> Back
        </router-link>
        <a
          href="javascript:;"
          class="btn btn-danger disabled:opacity-50 flex items-center"
          data-toggle="modal"
          data-target="#cancel-modal-preview"
          :disabled="btnCancel.disabled"
          v-show="!btnCancel.hide"
        >
          <XCircleIcon
            class="w-4 h-4 mr-2 hidden md:block"
            v-if="!btnCancel.loading"
          />
          <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
          ยกเลิกเอกสาร
        </a>
        <button
          type="button"
          class="btn box text-gray-700 disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-0"
          @click.prevent="saveMemo(true)"
          :disabled="btnDraft.disabled"
          v-show="!btnDraft.hide"
        >
          <FileTextIcon class="w-4 h-4 mr-2" v-if="!btnDraft.loading" />
          <LoadingIcon icon="oval" color="blue" v-else class="w-4 h-4 mr-2" />
          บันทึกแบบร่าง
        </button>
        <button
          type="button"
          class="btn btn-primary disabled:opacity-50 mr-2 flex items-center ml-auto sm:ml-0"
          @click.prevent="saveMemo(false)"
          :disabled="btnSave.disabled"
          v-show="!btnSave.hide"
        >
          <FileTextIcon class="w-4 h-4 mr-2" v-if="!btnSave.loading" />
          <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
          บันทึก และส่งอนุมัติ
        </button>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12">
        <div class="mt-5">
          <div class="w-10 h-10 w-full text-center my-20" v-if="loading">
            <LoadingIcon icon="oval" class="w-12 h-12" />
          </div>
          <div class="horizontal-form" v-else>
            <div class="grid grid-cols-2 space-x-4">
              <div class="intro-y box p-5 space-y-3">
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20">วันที่ </label>
                  <div>{{ formMemo.docDate }}</div>
                </div>
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20">เรื่อง</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="validateMemo.title.$model"
                    :class="{ 'border-theme-6': validateMemo.title.$error }"
                  />
                </div>
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20">หัวบริษัท</label>
                  <select
                    name=""
                    v-model="formMemo.comp_no"
                    class="form-select form-control"
                    :disabled="formMemo.docNoFull != ''"
                  >
                    <option
                      v-for="company in companyOptions"
                      :key="company.comp_no"
                      :value="company.comp_no"
                      >{{ company.comp_name_th }}</option
                    >
                  </select>
                </div>
              </div>

              <div class="intro-y box p-5 space-y-3">
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20">เรียน</label>
                  <div class="preview w-full">
                    <WfSelect
                      key="wfselect-to"
                      v-model="formMemo.toSelected"
                      :options="{
                        search: true,
                        multiple: true,
                        multipleLimit: 15,
                        searchMinLength: 3,
                        items: optionEmployee,
                        labelBy: 'fullname_th',
                        valueBy: 'employee_id'
                      }"
                    ></WfSelect>
                  </div>
                </div>
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20">ผ่าน</label>
                  <div class="preview w-full">
                    <WfSelect
                      key="wfselect-tocc"
                      v-model="formMemo.toccSelected"
                      :options="{
                        search: true,
                        multiple: true,
                        multipleLimit: 15,
                        searchMinLength: 3,
                        items: optionEmployee,
                        labelBy: 'fullname_th',
                        valueBy: 'employee_id'
                      }"
                    ></WfSelect>
                  </div>
                </div>
                <div class="form-inline">
                  <label for="" class="form-label sm:w-20">สำเนา</label>
                  <div class="preview w-full">
                    <WfSelect
                      key="wfselect-bcc"
                      v-model="formMemo.bccSelected"
                      :options="{
                        search: true,
                        multiple: true,
                        multipleLimit: 15,
                        searchMinLength: 3,
                        items: optionEmployee,
                        labelBy: 'fullname_th',
                        valueBy: 'employee_id'
                      }"
                    ></WfSelect>
                  </div>
                </div>
                <div class="form-inline flex items-start">
                  <label for="" class="form-label sm:w-20 pt-2">เสนอเพื่อ</label>
                  <div class="flex flex-row rounded-md p-2" :class="{ 'border border-theme-6': validateMemo.objectiveSelected.$error }">
                    <div
                      class="form-check mr-4"
                      v-for="item in optionObjectiveStatus"
                      :key="item.value"
                    >
                      <input
                        type="radio"
                        :id="`radio-${item.value}`"
                        class="form-radio-input"
                        :value="item.value"
                        v-model="validateMemo.objectiveSelected.$model"
                      />
                      <label
                        :for="`radio-${item.value}`"
                        class="form-check-label"
                        >{{ item.label }}</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="intro-y p-5 mt-5 box" v-if="formMemo.flag_edit == 2">
              <div class="text-theme-6 text-lg font-bold">
                เอกสารถูกตีกลับ
              </div>
              <span>หมายเหตุ: {{ formMemo.flag_edit_reason }}</span>
            </div>
            <div class="grid grid-cols-4 space-x-4">
              <div class="intro-y p-5 box col-span-3 mt-5" style="z-index: 0;">
                <div class="mb-4 ">เนื้อหา</div>
                <CKEditor
                  v-model="formMemo.detail"
                  :editor="classicEditor"
                  :config="editorConfig"
                  @ready="initDocumentEditor"
                />
              </div>
              <div class="intro-y p-5 box mt-5" style="z-index: 0;">
                <div class="mt-4 col-span-1">
                  <label class="form-label"
                    >ไฟล์แนบ {{ fileUploadMaxSize }}MB</label
                  >
                  <AttachFileUpload module="memo" />
                </div>
              </div>
            </div>
            <div class="mt-5" v-if="memoEdit">
              <TableHistory :items="formMemo.history_array" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- BEGIN: Modal Content -->

    <ModalCancel
      module="memo"
      doc-type="memo"
      :doc-id="formMemo.memoID"
      redirect-complete="memoDocAll"
    />
    <!-- END: Modal Content -->
  </div>
</template>

<script>
import 'vue-next-select/dist/index.css'
import {
  defineComponent,
  computed,
  ref,
  reactive,
  toRefs,
  onMounted,
  onUnmounted
} from 'vue'
import { useStore } from '@/store'
// import router from '@/router'
import { useRoute, useRouter } from 'vue-router'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import UnderlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight'

import TablePlugin from '@ckeditor/ckeditor5-table/src/table'
import TableToolbarPlugin from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import TablePropertiesPlugin from '@ckeditor/ckeditor5-table/src/tableproperties'
import TableCellPropertiesPlugin from '@ckeditor/ckeditor5-table/src/tablecellproperties'

import Font from '@ckeditor/ckeditor5-font/src/font'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import StrikethroughPlugin from '@ckeditor/ckeditor5-basic-styles/src/strikethrough'
import ListStylePlugin from '@ckeditor/ckeditor5-list/src/liststyle'
import TodoListPlugin from '@ckeditor/ckeditor5-list/src/todolist'
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment'

import AttachFileUpload from '@/components/attach-file/Upload.vue'
import ModalCancel from '@/components/ModalCancel.vue'

import WfSelect from '../../../components/select/Main.vue'
import TableHistory from '../../../components/TableHistory.vue'
// import vSelect from 'vue-select'
import helpers from '@/helpers'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import alert from '@/helpers/alert'
import { api } from '@/utils/api'

export default defineComponent({
  components: { WfSelect, AttachFileUpload, ModalCancel, TableHistory },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const btnSave = computed(() => store.state.memo.btnSave)
    const btnDraft = computed(() => store.state.memo.btnDraft)
    const btnCancel = computed(() => store.state.memo.btnCancel)

    const optionObjectiveStatus = computed(
      () => store.state.memo.objectiveStatus
    )
    const optionEmployee = computed(() => store.state.global.employeeAll)
    const companyOptions = computed(() => store.state.global.company)
    const fileUploadMaxSize = computed(
      () => store.state.global.fileUploadMaxSize
    )
    const formMemo = reactive({
      memoID: route.params.id || null,
      docDate: '',
      title: '',
      docNoFull: '',
      comp_no: store.state.auth.info.comp_no,
      detail: '',
      objectiveSelected: '',
      toSelected: [],
      toccSelected: [],
      bccSelected: [],
      flag_edit: 0,
      flag_edit_reason: null,
      history_array: []
    })

    const { dateFormat, fillBorderColor } = helpers

    const rules = {
      title: {
        required
      },
      objectiveSelected: {
        required
      }
    }
    const validateMemo = useVuelidate(rules, toRefs(formMemo))

    const classicEditor = ClassicEditor
    const editorConfig = {
      plugins: [
        Font,
        EssentialsPlugin,
        BoldPlugin,
        UnderlinePlugin,
        StrikethroughPlugin,
        ItalicPlugin,
        LinkPlugin,
        TablePlugin,
        TablePropertiesPlugin,
        TableToolbarPlugin,
        TableCellPropertiesPlugin,
        ParagraphPlugin,
        // CodePlugin,
        ListStylePlugin,
        // ListPlugin,
        TodoListPlugin,
        // Heading,
        // HeadingButtonsUI,
        Highlight,
        AlignmentPlugin
      ],
      toolbar: {
        items: [
          'fontSize',
          'fontColor',
          'fontBackgroundColor',
          'bold',
          'italic',
          'underline',
          'strikethrough',
          // 'code',
          'link',
          'undo',
          'redo',
          'insertTable',
          'highlight',
          'numberedList',
          'bulletedList',
          'todoList',
          'alignment'
        ]
      },
      table: {
        contentToolbar: [
          'tableColumn',
          'tableRow',
          'mergeTableCells',
          'tableProperties',
          'tableCellProperties'
        ]
      },
      alignment: {
        options: ['left', 'center', 'right']
      }
    }
    const initDocumentEditor = editor => {
      const toolbarContainer = document.querySelector(
        '.document-editor__toolbar'
      )
      toolbarContainer?.appendChild(editor.ui.view.toolbar.element)
      const win = window
      win.editor = editor
    }

    const loading = computed(() => store.state.global.loadingPage)
    const memoEdit = ref(false)

    const saveMemo = async isDraft => {
      validateMemo.value.$touch()
      if (validateMemo.value.$invalid) {
        alert.error()
        return false
      }

      if (isDraft) {
        store.commit('memo/setBtnActive', { type: 'btnDraft' })
      } else {
        store.commit('memo/setBtnActive', { type: 'btnSave' })
      }

      const data = {
        title: formMemo.title,
        detail: fillBorderColor(formMemo.detail),
        to: formMemo.toSelected,
        cc: formMemo.toccSelected,
        bcc: formMemo.bccSelected,
        objective_status: formMemo.objectiveSelected,
        doc_date: formMemo.docDate,
        attach_file: await store.getters['memo/getFileAttach'],
        comp_no: formMemo.comp_no,
        is_draft: isDraft,
        doc_owner: store.state.auth.info.employeeId,
        bu_no: store.state.auth.info.bu_no,
        username: store.state.auth.info.username
      }

      if (memoEdit.value) {
        await api
          .put(`/memo/memo/update/${formMemo.memoID}`, data)
          .then(res => {
            if (res.code == 200) {
              alert.success()
              if (!isDraft) {
                router.push({
                  name: 'memoMyActivitiesFormDetail',
                  params: { id: formMemo.memoID }
                })
              }
            } else {
              alert.error(res.message)
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      } else {
        await api
          .post('/memo/memo/insert', data)
          .then(res => {
            if (res.code == 200) {
              formMemo.memoID = res.data.id
              memoEdit.value = true
              alert.success()
              store.commit('memo/setBtn', {
                type: 'btnCancel',
                value: 'hide'
              })
              if (!isDraft) {
                router.push({
                  name: 'memoMyActivitiesFormDetail',
                  params: { id: formMemo.memoID }
                })
              }
            } else {
              alert.error(res.message)
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      }

      if (isDraft) {
        store.commit('memo/setBtnActive', { type: 'btnDraft' })
      } else {
        store.commit('memo/setBtnActive', { type: 'btnSave' })
        // router.push({
        //   name: 'memoMyActivitiesFormDetail',
        //   params: { id: formMemo.memoID }
        // })
      }
    }

    const getMemo = async () => {
      if (route.params.id) {
        await api
          .get(`/memo/memo/getById/${route.params.id}`)
          .then(res => {
            if (res.code == 200) {
              formMemo.title = res.data.title
              formMemo.detail = res.data.detail ? res.data.detail : ''
              formMemo.toSelected = res.data.to_array.map(to => {
                return to.employee_id
              })
              formMemo.toccSelected = res.data.cc_array.map(cc => {
                return cc.employee_id
              })
              formMemo.bccSelected = res.data.bcc_array.map(bcc => {
                return bcc.employee_id
              })
              formMemo.objectiveSelected = res.data.objective_status
              formMemo.docDate = res.data.doc_date
                ? res.data.doc_date.split(' ')[0]
                : ''
              formMemo.comp_no = res.data.comp_no
              formMemo.memoID = res.data.id
              formMemo.docNoFull = res.data.doc_no_full
              formMemo.flag_edit = res.data.flag_edit
              formMemo.flag_edit_reason = res.data.flag_edit_reason
              formMemo.history_array = res.data.history_array

              for (const i in res.data.attach_file_array) {
                store.commit('memo/setFile', res.data.attach_file_array[i])
              }

              if (
                (res.data.status_code == 'wait' ||
                  res.data.status_code == 'draft') &&
                res.data.doc_owner.employee_id ==
                  store.state.auth.info.employeeId
              ) {
                store.commit('memo/setBtn', {
                  type: 'btnCancel',
                  value: 'hide'
                })
              }
              memoEdit.value = true
            } else {
              alert.error(res.message)
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      }
    }

    const cancelMemo = async () => {
      await store.commit('memo/setBtnActive', { type: 'btnCancel' })
      await store.dispatch('memo/cancelMemo', formMemo.memoID)
    }

    onUnmounted(() => {
      // console.log('unmounted: ')
      store.commit('global/setLoadingPage', true)
      store.commit('memo/initBtn')
    })

    onMounted(async () => {
      // getEditMemo()
      store.dispatch('memo/loadOptionObject')
      store.dispatch('global/loadEmployeeAll')
      store.dispatch('global/loadCompany')
      store.dispatch('global/loadFileUploadMaxSize')

      store.commit('memo/setBtn', { type: 'btnSave', value: 'hide' })
      store.commit('memo/setBtn', { type: 'btnDraft', value: 'hide' })
      // store.commit('memo/setBtn', { type: 'btnCancel', value: 'hide' })
      formMemo.docDate = dateFormat(new Date())
      await getMemo()
      await store.commit('global/setLoadingPage', false)
    })

    return {
      classicEditor,
      editorConfig,
      initDocumentEditor,
      optionObjectiveStatus,
      optionEmployee,
      companyOptions,
      saveMemo,
      cancelMemo,
      memoEdit,
      fileUploadMaxSize,
      validateMemo,
      loading,
      btnSave,
      btnDraft,
      btnCancel,
      dateFormat,
      formMemo
    }
  }
})
</script>
